import {API_ENDPOINT_JSON} from '../../../../../config';

export const getCdpUrl = (pillarId: string): string => {
  return `${API_ENDPOINT_JSON.ESG.CDP.cdp}/${pillarId}`;
};

export const getCdpCorporateUrl = (pillarId: string): string => {
  return `${API_ENDPOINT_JSON.ESG.CDP_CORPORATE.cdpcorporate}/${pillarId}`;
};
